/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : integrationConfigAction.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
const { default: actionType } = require("../actionTypes");

const integrationConfigAction = {
  get_connectors: {
    api_name: "/ICM/connectors/view",
    https_method: "GET",
    action_type: actionType.GET_CONNECTORS,
    description: "Get the Connectors",
  },
  test_connectors: {
    api_name: "/ICM/connectors/test",
    https_method: "POST",
    action_type: actionType.TEST_CONNECTORS,
    description: "Test the Connectors",
  },
  add_integrations: {
    api_name: "/ICM/integrations/add",
    https_method: "POST",
    action_type: actionType.ADD_INTEGRATION,
    description: "Add the Integrations",
  },
  view_integrations: {
    api_name: "/ICM/integrations/view",
    https_method: "GET",
    action_type: actionType.GET_INTEGRATION,
    description: "Get the Integrations",
  },
  update_integrations: {
    api_name: "/ICM/integrations/update",
    https_method: "PUT",
    action_type: actionType.UPDATE_INTEGRATION,
    description: "Remove/Disconnect the Integrations",
  },
  save_integrations: {
    api_name: "/ICM/integrations/save",
    https_method: "PUT",
    action_type: actionType.SAVE_INTEGRATION,
    description: "Save the Integrations",
  },
  sync_test_cases_from_xray: {
    api_name: "/ICM/connectors/invoke",
    https_method: "POST",
    action_type: actionType.SYNC_TEST_CASES_FROM_XRAY,
    description: "Sync test cases from Xray",
  },
  import_single_test_case: {
    api_name: "/ICM/connectors/invoke",
    https_method: "POST",
    action_type: actionType.IMPORT_SINGLE_TEST_CASE,
    description: "Import single test case from Xray",
  },
  import_multiple_test_cases: {
    api_name: "/ICM/connectors/invoke",
    https_method: "POST",
    action_type: actionType.IMPORT_MULTIPLE_TEST_CASES,
    description: "Import multiple test cases from Xray",
  },
};

module.exports = integrationConfigAction;
